// eslint-disable-next-line import/named
import { TListenerApi } from '@myua/rtk-helper';
import * as generalActions from '../actions';
import { api } from '../apiScenarios';
import { CurrentUser } from '../model';

export async function loadUser<TStoreShape>(lapi: Pick<TListenerApi<TStoreShape>, 'dispatch'>) {
  lapi.dispatch(generalActions.loadUserStarted());
  const result = await api.oauth.user<CurrentUser>();
  if (result.success) {
    lapi.dispatch(generalActions.loadUserSuccess({ user: result.data.response }));
  } else {
    lapi.dispatch(generalActions.loadUserError({ error: result.reason }));
  }
}
